import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import { WorldIcon, StarIcon, Oval1Icon, RopIcon } from "../constant";
import { styled } from "@mui/material/styles";

const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "100%",
        right: "60%",
        top: "0",
        bottom: "10%",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
       // backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
        width: "97%",
    },
}));





const FourCardsSwap = ({ title, subTitle, cardData }) => {
    return (
        <MainContainer>
            <ContentContainer>
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    sx={{ width: { xs: "100%", md: "80%" } }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb: 3,
                            textAlign: "center",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "14px", md: "18px" },
                            lineHeight: 1.8,
                            textAlign: "center",
                            marginTop: 2,
                            marginBottom: 10,
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={8}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6}>
                                <Box className="industrie-action-card1" sx={{ background: "#1A1A1A" }}>
                                    <Box className="industrie-card-body1">

                                        <Box className="info1">
                                            <Typography variant="h4" className="intro-text1">
                                                <Box
                                                    sx={{
                                                        width: { xs: "80px", sm: "100px", md: "120px", lg: "150px" }, // Responsive width
                                                        height: { xs: "80px", sm: "75px", md: "90px", lg: "110px" }, // Responsive height
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={RopIcon}
                                                        sx={{
                                                            width: "100%",
                                                            height: "100%",
                                                            // objectFit: "contain", // Use "cover" if you want it to fill and crop
                                                        }}
                                                        alt="icon"
                                                    />
                                                </Box>

                                                <br />
                                                {cardData[0]?.title}
                                            </Typography>
                                            <Typography>{cardData[0]?.description}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <Box className="industrie-action-card1" sx={{ background: "#07329F" }}>
                                    <Box className="industrie-card-body1">
                                        <Box className="info1">
                                            <Typography variant="h4" className="intro-text1">

                                                <Box
                                                    sx={{
                                                        width: { xs: "80px", sm: "100px", md: "120px", lg: "150px" }, // Responsive width
                                                        height: { xs: "80px", sm: "75px", md: "90px", lg: "110px" }, // Responsive height
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={WorldIcon}
                                                        sx={{
                                                            width: "100%",
                                                            height: "100%",
                                                            // objectFit: "contain", // Use "cover" if you want it to fill and crop
                                                        }}
                                                        alt="icon"
                                                    />
                                                </Box>
                                                <br />
                                                {cardData[1]?.title}
                                            </Typography>
                                            <Typography>{cardData[1]?.description}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>


                            <Grid item xs={12} md={12}>
                                <Box className="industrie-action-card3">
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: { xs: "column", md: "row" }, // Mobile: Column | Desktop: Row
                                            alignItems: { xs: "center", md: "center" }, // Center in mobile, align in desktop
                                            justifyContent: "space-between",
                                            padding: 2,
                                            gap: 2, // Space between elements
                                        }}
                                    >
                                        {/* Left: Icon + Title (Center in mobile, left in desktop) */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 6, // Space between icon and text
                                                flexShrink: 0,
                                                flexDirection: { xs: "column", md: "row" }, // Column on mobile, Row on desktop
                                                textAlign: { xs: "center", md: "left" }, // Centered in mobile, left in desktop
                                            }}
                                        >
                                            <img src={StarIcon}
                                                className="star-icon"
                                                sx={{
                                                    width: { xs: "50px", md: "60px" },
                                                    height: "auto",
                                                    transition: "transform 0.3s ease-in-out, color 0.3s ease-in-out",
                                                    background: 'transparent'
                                                }}
                                                alt=""
                                            />
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    color: "#fff",
                                                }}
                                            >
                                                {cardData[2]?.title}
                                            </Typography>
                                        </Box>

                                        {/* Right: Description (Left-aligned in both views) */}
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "#fff",
                                                maxWidth: { xs: "100%", md: "40%" }, // Full width in mobile, 40% in desktop
                                                textAlign: "left", // Always left-aligned
                                            }}
                                        >
                                            {cardData[2]?.description}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>


                        </Grid>
                    </Grid>

                    {/* last card  */}
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Box className="industrie-action-card2" sx={{ background: "#1A1A1A" }}>
                            <Box className="info1">
                                <Box sx={{ display: "flex", justifyContent: "left" }}>
                                    <Box
                                        sx={{
                                            width: { xs: "80px", sm: "100px", md: "120px", lg: "150px" }, // Responsive width
                                            height: { xs: "80px", sm: "75px", md: "90px", lg: "110px" }, // Responsive height
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            overflow: "hidden",
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={Oval1Icon}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                // objectFit: "contain", // Use "cover" if you want it to fill and crop
                                            }}
                                            alt="icon"
                                        />
                                    </Box>
                                </Box>

                                {/* Bottom-Aligned Text */}
                                <Box sx={{ textAlign: "left", marginTop: "170px" }}>
                                    <Typography variant="h4" className="intro-text1">
                                        {cardData[3]?.title}
                                    </Typography>
                                    <Typography variant="body2">{cardData[3]?.description}</Typography>
                                </Box>
                            </Box>

                        </Box>
                    </Grid>
                </Grid>

            </ContentContainer>
        </MainContainer>
    );
};

export default FourCardsSwap;


